/**
 * Apply lens to data for projection
 */

import { useMemo } from 'react';
import type { Block } from '../types';
import { getLens } from '../lenses';

interface LensProjectionResult {
  projectedLines: string[];
  isValid: boolean;
  error?: string;
}

export const useLensProjection = (
  lensId: string,
  position: number,
  cascade: Block | null
): LensProjectionResult => {
  const result = useMemo((): LensProjectionResult => {
    try {

      // Validate inputs
      if (!cascade) {
        return {
          projectedLines: [],
          isValid: false,
          error: 'No cascade data available',
        };
      }

      if (position < 0 || position > 1) {
        return {
          projectedLines: [],
          isValid: false,
          error: 'Position must be between 0 and 1',
        };
      }

      // Get the lens
      const lens = getLens(lensId);

      // Apply the lens projection
      const projectedLines = lens.project(position, cascade);

      return {
        projectedLines,
        isValid: true,
      };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown projection error';

      return {
        projectedLines: [],
        isValid: false,
        error: errorMessage,
      };
    }
  }, [lensId, position, cascade]);

  return result;
};